<template>
  <v-sheet class="medias-section" color="grey lighten-2">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <div v-if="!loading">
        <v-container>
          <v-row>
            <template v-for="(item, i) in mediasArray">
              <v-col cols="12" sm="6" :key="i">
                <MediasCard v-bind="item" />
              </v-col>
            </template>
          </v-row>
        </v-container>
      </div>
    </transition>
  </v-sheet>
</template>

<script>
import { getTelLinkFromPhone } from "../../utils/getTelLinkFromPhone";
import { getYoutubeCode } from "../../utils/getYoutubeCode";

import MediasCard from "../cards/MediasCard.vue";
import LoadingWidget from "../widgets/LoadingWidget.vue";
const _config = {
  mod: "medias",
};
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    medias() {
      return this.$rest(_config.mod).item;
    },
    mediasArray() {
      return [
        {
          title: "JC NA TV",
          img: this.medias.img_tv
            ? this.files + this.medias.img_tv
            : `https://img.youtube.com/vi/${getYoutubeCode(
                this.medias.video_tv
              )}/maxresdefault.jpg`,

          video:
            "https://www.youtube.com/embed/" +
            getYoutubeCode(this.medias.video_tv),
          tel: this.medias.tel_tv,
          telLink: getTelLinkFromPhone(this.medias.tel_tv),
          text: this.medias.text_tv,
          bg: "red",
        },
        {
          title: "JC NA RÁDIO",
          img: this.medias.img_radio
            ? this.files + this.medias.img_radio
            : `https://img.youtube.com/vi/${getYoutubeCode(
                this.medias.video_radio
              )}/maxresdefault.jpg`,

          video:
            "https://www.youtube.com/embed/" +
            getYoutubeCode(this.medias.video_radio),
          tel: this.medias.tel_radio,
          telLink: getTelLinkFromPhone(this.medias.tel_radio),
          text: this.medias.text_radio,
          bg: "green",
        },
      ];
    },
  },

  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  methods: {},
  components: {
    LoadingWidget,
    MediasCard,
  },
};
</script>

<style lang="scss" scoped>
.medias-section {
  margin-top: 80px;
  padding-top: 80px;
  padding-bottom: 70px;
  @media (max-width: 1264px) {
    margin-top: 60px;
    padding-top: 60px;
    padding-bottom: 50px;
  }
  @media (max-width: 960px) {
    margin-top: 40px;
    padding-top: 40px;
    padding-bottom: 30px;
  }
}
</style>
